import { ImageToPdfForm } from '@/features/image-to-pdf'

export function PngVPdfForm() {
  return <ImageToPdfForm mode="png" />
}
